import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import axios from 'axios';
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./authConfig";

const msalInstance = new PublicClientApplication(msalConfig);


ReactDOM.render(
  <MsalProvider instance={msalInstance}>
    <App />   
  </MsalProvider>
  ,
  document.getElementById('root')
);

